<template>
  <div id="top" :class="{ 'vue-lightbox' : !resetstyles }">
    <h1 v-if="title">{{ title }}</h1>
    <ul>
      <li v-for="(image, index) in images" v-bind:key = "index">
          <img :src="'/static/upload/'+image.thumb" :alt="image.autor" @click="clickImage(index, image.url)" style="cursor: pointer;">
      </li>
     </ul>
     <div class="lightbox-overlay" v-if="overlayActive && images.length > currentImage" @click.self="closeOverlay">
      <div class="holder" style="position:relative">
        <img ref="fullImg" style="background: url(@/assets/img/loading.gif) 50% no-repeat;" />
        <img v-if="loading" src="@/assets/img/loading.gif" style="position: fixed;
        width: 50px;
        height: 50px;
        top: 50%;
        left: 50%;z-index: 1000;margin-top: -25px;margin-left: -25px;" />
        <div class="nav" v-if="nav">
          <a class="close" nohref @click="closeOverlay"><span>&times;</span></a>
          <a class="downloadit" @click="downloadImage(images[currentImage])"><span>&#11015;</span></a>
          <a class="prev" nohref @click="prevImage"><span>&#8592;</span></a>
          <a class="next" nohref @click="nextImage"><span>&#8594;</span></a>
        </div>
        <p v-if="caption && images[currentImage].autor">{{ images[currentImage].autor }}</p>
      </div>
     </div>
     <div id="imageNavigation">
        <a v-if="currentIndex > 0" @click="prevPage()"><span style="font-size:30px; cursor: pointer;">&#8592;</span></a>
        <a v-if="(currentIndex + 1) * show < imagesAll.length" @click="nextPage()"><span style="font-size:30px; cursor: pointer;">&#8594;</span></a>
      </div>
  </div>
</template>

<script>
import objectFitImages from 'object-fit-images'
import {detectIE} from '@/utils/utils.js'

export default {
  props: {
    resetstyles: {
      default: false,
      type: Boolean
    },
    loop: {
      default: true,
      type: Boolean
    },
    nav: {
      default: true,
      type: Boolean
    },
    caption: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      currentImage: null,
      overlayActive: false,
      imagesAll: [],
      title: '',
      testURL: '/static/upload/getImages.php',
      currentIndex: 0,
      show: 30,
      galleryname: '',
      loading: false
    }
  },
  watch: {
    '$route.params.gal' (to, from) {
      // update the variables with new route params
      this.galleryname = this.$route.params.gal
      if (this.galleryname === 'Fotografin') {
        this.testURL = '/static/upload/getImages.php?galleryname=fotografin'
      } else {
        this.testURL = '/static/upload/getImages.php'
      }
      this.currentIndex = 0
      this.loadImages()
    },
    '$route.params.page': function (page) {
      this.currentIndex = parseInt(page)
      this.overlayActive = false
      if (detectIE() !== false) {
        this.$nextTick(() => {
          objectFitImages()
        })
      }
    },
    '$route.params.img': function (img) {
      var imgIndex = parseInt(img)
      if (imgIndex < this.show && this.images.length >= imgIndex) {
        this.currentImage = imgIndex
        this.overlayActive = true
        this.loading = true
        const self = this
        this.$nextTick(() => {
          var image = this.$refs['fullImg']
          var downloadingImage = new Image()
          downloadingImage.onload = function () {
            image.src = this.src
            self.loading = false
          }
          downloadingImage.src = '/static/upload/' + this.images[this.currentImage].url
        })
      } else {
        this.overlayActive = false
      }
    }
  },
  created: function () {
    this.galleryname = this.$route.params.gal
    if (this.galleryname === 'Fotografin') {
      this.testURL = '/static/upload/getImages.php?galleryname=fotografin'
    } else {
      this.testURL = '/static/upload/getImages.php'
    }
    this.currentIndex = 0
    this.currentImage = 0
    var page = parseInt(this.$route.params.page)
    if (page >= 0) {
      this.currentIndex = page
    }
    var img = parseInt(this.$route.params.img)
    if (img <= this.show) {
      this.overlayActive = true
      this.currentImage = img
    }
    this.loadImages()
  },
  mounted () {
    const self = this
    window.addEventListener('keydown', (e) => {
      self.handleGlobalKeyDown(e)
    })
  },
  computed: {
    images: function () {
      return this.paginate(this.imagesAll, this.show, this.currentIndex)
    }
  },
  methods: {
    clickImage (index, url) {
      this.$router.push('/gallery/' + this.$route.params.gal + '/' + this.currentIndex + '/' + index)
      this.$ga.event({eventCategory: 'image clicked', eventAction: url, eventLabel: url + ' - clicked'})
    },
    nextImage () {
      var newIndex = this.currentIndex
      var newImg = this.currentImage
      if (this.currentImage === (this.images.length - 1)) {
        if ((this.currentIndex + 1) * this.show < this.imagesAll.length) {
        // if (this.loop) {
          newIndex = this.currentIndex + 1
          newImg = 0
        } else {
          newIndex = 0
          newImg = 0
        }
      } else {
        newImg = this.currentImage + 1
      }
      this.$router.push('/gallery/' + this.$route.params.gal + '/' + newIndex + '/' + newImg)
    },
    prevImage () {
      var newIndex = this.currentIndex
      var newImg = this.currentImage
      if (this.currentImage === 0) {
        if (this.currentIndex > 0) {
          newIndex = this.currentIndex - 1
          newImg = this.show - 1
        } else {
          var maxIndex = Math.floor(this.imagesAll.length / this.show) + 1
          newImg = this.show - (maxIndex * this.show - this.imagesAll.length) - 1
          newIndex = maxIndex - 1
        }
      } else {
        newImg = this.currentImage - 1
      }
      this.$router.push('/gallery/' + this.$route.params.gal + '/' + newIndex + '/' + newImg)
    },
    closeOverlay () {
      this.overlayActive = false
      this.$router.push('/gallery/' + this.$route.params.gal + '/' + this.currentIndex)
    },
    handleGlobalKeyDown (e) {
      switch (e.keyCode) {
        case 37: this.prevImage(); break
        case 39: this.nextImage(); break
        case 27: this.closeOverlay(); break
        default: break
      }
    },
    loadImages () {
      this.imagesAll = []
      const self = this
      const myInit = {
        method: 'GET',
        mode: 'cors'
      }
      const myRequest = new Request(this.testURL, myInit)
      fetch(myRequest).then(function (response) {
        return response.json()
      }).then(function (myJson) {
        // console.log(JSON.stringify(myJson))
        self.imagesAll = myJson
        if (self.currentIndex > self.imagesAll.length / self.show) {
          self.currentIndex = 0
          self.$router.push('/gallery/' + self.$route.params.gal + '/' + self.currentIndex)
        }
        self.$nextTick(() => {
          if (self.overlayActive && self.currentImage >= 0 && self.currentImage < self.show && self.currentImage < self.images.length) {
            var image = self.$refs['fullImg']
            var downloadingImage = new Image()
            downloadingImage.onload = function () {
              image.src = this.src
            }
            downloadingImage.src = '/static/upload/' + self.images[self.currentImage].url
          }
          objectFitImages()
        })
      }).catch(function (e) {
        console.log('Bad Response')
        var i = 0
        while (i < 70) {
          self.imagesAll.push({url: '20180828_144428.jpg', autor: '1', thumb: '20180828_144428.jpg'})
          i = i + 1
        }
        if (self.overlayActive && self.currentImage >= 0 && self.currentImage < self.show && self.currentImage < self.images.length) {
          self.$nextTick(() => {
            var image = self.$refs['fullImg']
            var downloadingImage = new Image()
            downloadingImage.onload = function () {
              image.src = this.src
            }
            downloadingImage.src = '/static/upload/' + self.images[self.currentImage].url
          })
        }
        if (self.currentIndex > self.imagesAll.length / self.show) {
          self.currentIndex = 0
          self.$router.push('/gallery/' + self.$route.params.gal + '/' + self.currentIndex)
        }
      })
    },
    paginate (array, pageSize, pageNumber) {
      return array.slice(pageNumber * pageSize, (pageNumber + 1) * pageSize)
    },
    nextPage () {
      this.currentIndex += 1
      // this.$forceUpdate()
      if (detectIE() !== false) {
        this.$nextTick(() => {
          objectFitImages()
        })
      }
      this.$router.push('/gallery/' + this.$route.params.gal + '/' + this.currentIndex)
      this.$scrollTo('#app', 100)
    },
    prevPage () {
      this.currentIndex -= 1
      this.$router.push('/gallery/' + this.$route.params.gal + '/' + this.currentIndex)
      if (detectIE() !== false) {
        this.$nextTick(() => {
          objectFitImages()
        })
      }
    },
    downloadImage (img) {
      this.$ga.event({eventCategory: 'image dowloaded', eventAction: img.url, eventLabel: img.url + ' - downloaded'})
      window.location = '/static/upload/getImage.php?file=' + img.url
    }
  }
}
</script>

<style scoped lang="scss">
.vue-lightbox ul {
  list-style: none;
  margin: 0 auto;
  padding: 0;
  display: block;
  text-align: center;
  li {
    display: inline-block;
    padding: 5px;

        img {
            object-fit: cover;
            font-family: 'object-fit: cover;';
            display: block;
            width: 300px;
            height: 200px;
        }
  }
}

.lightbox-overlay {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0,0,0,0.9);
  text-align: center;
  padding: 10px;
  box-sizing: border-box;

  .holder {
    max-width: 100%;
    margin: 0 auto;
    position: relative;
    /* max-height: 100vh; */

    img {
      max-width: 100%;
      max-height: 92vh;
      cursor: pointer;
      box-sizing: border-box;
      /* display: block; */
    }
    p {
      color: #ffffff;
      margin: 0;
      background-color: rgba(0,0,0,0.4);
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      box-sizing: border-box;
      padding-top: 2px;
    }
    .nav {
      max-width: 100%;
      margin: 0 auto;
      font-size: 14px;

      a {
        color: white;
        opacity: 0.4;
        -webkit-user-select: none;
        cursor: pointer;

        &:hover {
          opacity: 1;
        }
      }

      .next, .prev {
        position: absolute;
        top: 0;
        bottom: 0;
        padding: 10px;
        width: 50%;
        box-sizing: border-box;
        font-size: 40px;

        span {
          top: 50%;
          transform: translateY(50%);
          position: relative;
        }
      }

      .next {
        right: 0;
        text-align: right;
      }

      .prev {
        left: 0;
        text-align: left;
      }
      .close {
        right: 10px;
        top: 0;
        font-size: 30px;
          opacity: 0.8;
        z-index: 1000000;
        position: absolute;
        text-align: left;
        box-sizing: border-box;

        &:hover {
          opacity: 1;
        }
      }
      .downloadit {
        left: 10px;
        top: 0;
        font-size: 30px;
          opacity: 0.8;
        z-index: 1000000;
        position: absolute;
        text-align: left;
        box-sizing: border-box;

        &:hover {
          opacity: 1;
          text-decoration: none;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue